import classNames from "classnames";
import { DComponent } from "../../../../../../components/DComponent";
import { ProductGroupSite } from "../../../../../../models/ProductGroupSite";
import { getPriceText } from "../../../../../../utils/currency";

export default class ItemCart extends DComponent {
  constructor({
    parent,
    id,
    productGroupSite = new ProductGroupSite(),
    hasSpace = false
  } = {}) {
    let subTotal = 0, totalQuantity = 0, currentCurrency;
    productGroupSite.products.forEach(element => {
      if (element.canSelected()) {
        subTotal += element.quantity * element.price;
        totalQuantity += element.quantity;
        currentCurrency = element.currentCurrency;
      }
    });

    const idItems = totalQuantity > 1 ? "checkout_items" : "checkout_item";
    super(arguments[0], parent, id, {
      class: classNames("ItemCart", {
        "has-space": hasSpace
      }),
      siteLogo: productGroupSite.site.siteMeta.logoUrl || `https://www.google.com/s2/favicons?domain=${productGroupSite.site.domain}`,
      siteName: productGroupSite.site.domain,
      totalQuantity: totalQuantity,
      idItems: idItems,
      idItemsValue: $.i18n(idItems),
      totalPrice: getPriceText(subTotal, currentCurrency),
    }, true);
    this.productGroupSite = productGroupSite;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "ItemCart");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {

  }
}